/**
 * Products slider – Swiper se slidesPerView: 'auto'.
 *
 * Šířky slidů určuje CSS (viz #products-swiper .swiper-slide), slider je
 * responzivní automaticky – zobrazí tolik auto-šířkových slidů, kolik se vejde,
 * zbytek "peekuje" za okraj (SCSS: overflow: visible). Swiper je globál
 * z vendor bundle (swiper-bundle.min.js).
 */
function initProductsSlider() {
    const el = document.getElementById('products-swiper');
    if (!el || typeof Swiper === 'undefined') return;

    new Swiper(el, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        grabCursor: true,
        mousewheel: {
            forceToAxis: true, // jen vodorovné gesto (2 prsty doleva/doprava na trackpadu)
        },
        watchOverflow: true,
        navigation: {
            nextEl: '#products .slider-nav--next',
            prevEl: '#products .slider-nav--prev',
        },
        breakpoints: {
            820: { spaceBetween: 24 },
            1280: { spaceBetween: 30 },
        },
    });
}

document.addEventListener('DOMContentLoaded', initProductsSlider);
